exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".padding-fixed-summary{padding:1.8rem 1rem!important}.fixed-booking-summary{position:fixed;z-index:45;bottom:0;left:0;width:100%;background-color:#fff;padding:1rem;box-shadow:0 -2px 13px -3px rgba(0,0,0,.15)}.fixed-booking-summary .container{padding:0!important;max-width:90vw!important}@media (min-width:1100px){.fixed-booking-summary .container{max-width:1000px!important}}.fixed-booking-summary .collapsible-section{margin-bottom:1.4rem}.fixed-booking-summary .sticky-section{z-index:10}.fixed-booking-summary .sticky-section .show-more-btn,.fixed-booking-summary .sticky-section .v-card__price{font-family:Avenir;padding:0}.fixed-booking-summary .sticky-section .show-more-btn .v-btn__content,.fixed-booking-summary .sticky-section .v-card__price .v-btn__content{font-family:Avenir-Heavy;font-size:1rem}@media screen and (min-width:768px){.fixed-booking-summary{padding:1.5rem 1rem}}@media screen and (min-width:1024px){.fixed-booking-summary{padding:2rem 1rem}.fixed-booking-summary .sticky-section .v-card__price{font-size:1.2rem}}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};